<p-card styleClass="p-3 very-compact-card mb-3">
  <p-steps
    [model]="steps"
    [activeIndex]="activeIndexStep"></p-steps>
</p-card>

<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <ng-container *ngIf="!activeIndexStep">
            <div class="field">
              <label class="font-medium required-field">Email</label>
              <crm-input-text
                [(value)]="email.email"
                [isError]="$any(errorEmail?.email)"></crm-input-text>
              <small
                *ngIf="errorEmail?.email"
                class="p-error">
                {{ errorEmail?.email | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 1">
            <div class="field">
              <label class="font-medium required-field">Имя</label>
              <crm-input-text
                [(value)]="profileRegister.firstName"
                [isError]="$any(errorProfileRegister?.firstName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.firstName"
                class="p-error">
                {{ errorProfileRegister?.firstName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Фамилия</label>
              <crm-input-text
                [(value)]="profileRegister.lastName"
                [isError]="$any(errorProfileRegister?.lastName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.lastName"
                class="p-error">
                {{ errorProfileRegister?.lastName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Отчество</label>
              <crm-input-text
                [(value)]="profileRegister.middleName"
                [isError]="$any(errorProfileRegister?.middleName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.middleName"
                class="p-error">
                {{ errorProfileRegister?.middleName | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 2">
            <div class="field">
              <label class="font-medium">Должность</label>
              <crm-input-text
                [(value)]="user.job"
                [isError]="$any(errors?.job)"></crm-input-text>
              <small
                *ngIf="errors?.job"
                class="p-error">
                {{ errors.job | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium required-field">Роли</label>
              <crm-standard-multi-select
                [descriptorApiUrl]="roleDropdownDescriptorUrl"
                [(selectedValues)]="user.roles"
                [class]="errors?.roles ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.roles ? 'ng-invalid ng-dirty' : ''"
                appendTo="body"></crm-standard-multi-select>
              <small
                *ngIf="errors?.roles"
                class="p-error">
                {{ errors.roles | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Контрагент</label>
              <crm-contragent-auto-complete
                [(selectedContragent)]="user.contragent"
                [customSearch]="false"
                [showClear]="true"
                [isError]="$any(errors?.contragent)"
                appendTo="body">
              </crm-contragent-auto-complete>
              <small
                *ngIf="errors?.contragent"
                class="p-error">
                {{ errors.contragent | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">График работы</label>
              <crm-single-select
                [(selectedItem)]="user.workSchedule"
                [options]="schedules"
                [class]="errors?.workSchedule ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.workSchedule ? 'ng-invalid ng-dirty' : ''"
                appendTo="body">
              </crm-single-select>
              <small
                *ngIf="errors?.workSchedule"
                class="p-error">
                {{ errors.workSchedule | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Схема согласования</label>
              <crm-approval-scheme-single-select
                [(selectedApprovalScheme)]="user.approvalScheme"
                [isError]="$any(errors?.approvalScheme)"
                appendTo="body"></crm-approval-scheme-single-select>
              <small
                *ngIf="errors?.approvalScheme"
                class="p-error">
                {{ errors.approvalScheme | join }}
              </small>
            </div>
          </ng-container>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <crm-button
      *ngIf="activeIndexStep"
      icon="pi pi-arrow-left"
      label="Назад"
      styleClass="p-button-text p-button-secondary mr-2"
      (onClick)="back()"></crm-button>

    <crm-button
      [label]="activeIndexStep === 2 ? 'Добавить' : 'Далее'"
      styleClass="p-button-success"
      (onClick)="saveUser()"></crm-button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
